export const STATUS_LABELS = [
  'Not Started',
  'Arrived',
  'In Progress',
  'Ready for Pickup',
  'In Transit',
  'Picked Up',
  'Delivered',
  'Exception',
];

export const STATUS_API_VALUES = {
  0: 'not_started',
  1: 'arrived',
  2: 'in_progress',
  3: 'ready',
  4: 'in_transit',
  5: 'picked_up',
  6: 'delivered',
  7: 'exception',
};

export const STATUS_STRING_TO_NUMERIC = {
  not_started: 0,
  arrived:     1,
  in_progress: 2,
  ready:       3,
  in_transit:  4,
  picked_up:   5,
  delivered:   6,
  exception:   7,
};

export const STATUS_PIPELINE = {
  arrived: "Arrived",
  in_progress: "Halfway",
  ready: "Ready",
  picked_up: "Picked Up",
  delivered: "Delivered",
};

export const STATUS_PIPELINE_TRANSIT = {
  arrived: "Arrived",
  in_progress: "Halfway",
  in_transit: "In Transit",
  delivered: "Delivered",
};

export const STATUS_PIPELINE_TRANSIT_DROP = {
  arrived:     "Arrived",
  in_progress: "Halfway",
  in_transit:  "In Transit",
  ready:       "Ready",
  picked_up:   "Picked Up",
  delivered:   "Delivered",
};

export const PHLEBONLY_STATUS_LABEL = {
  0: 'Not Started',
  1: 'Arrived',
  2: 'In Progress',
  3: 'Complete',
  4: 'Delivered',
  6: 'In Transit',
};

export const PHLEBONLY_STRING_TO_NUMERIC = {
  not_started:  0,
  arrived:      1,
  in_progress:  2,
  complete:     3,
  delivered:    4,
  in_transit:   6,
};

export const STATUS_FROM_API = {
  not_started: "Not Started",
  arrived:     "Arrived",
  in_progress: "In Progress",
  ready:       "Ready for Pickup",
  picked_up:   "Picked Up",
  delivered:   "Delivered",
  in_transit:  "In Transit",
  exception:   "Exception",
  complete:    "Complete",
};

export const PHLEBONLY_PIPELINE = {
  'arrived':     'Arrived',
  'in_progress': 'Halfway',
  'complete':    'Complete',
  'in_transit':  'In Transit',
  'delivered':   'Delivered',
};


export function formatHHMM(timeVal) {
  if (timeVal == null || timeVal === '') return '—';

  if (typeof timeVal === 'string' && timeVal.includes(':')) {
    const [h, m] = timeVal.split(':').map(Number);
    if (!isNaN(h) && !isNaN(m)) {
      const period = h >= 12 ? 'PM' : 'AM';
      return `${h % 12 || 12}:${String(m).padStart(2, '0')} ${period}`;
    }
    return timeVal;
  }

  if (typeof timeVal === 'number') {
    const h = Math.floor(timeVal / 60);
    const m = timeVal % 60;
    const period = h >= 12 ? 'PM' : 'AM';
    return `${h % 12 || 12}:${String(m).padStart(2, '0')} ${period}`;
  }

  return String(timeVal);
}

export function formatApiTime(minutesSinceMidnight) {
  return formatHHMM(minutesSinceMidnight);
}

export const STATUS_CLASSES = ['s0', 's1', 's2', 's3', 's4', 's5', 's6', 's7'];

export const getStatusLabel = (s) => STATUS_LABELS[s] ?? '?';
export const getStatusClass = (s) => STATUS_CLASSES[s] ?? 's0';

export const PHLEBONLY_STATUS_CLASSES = ['s0', 's1', 's2', 's5', 's4', 's6'];
export const getPhlebOnlyStatusClass = (s) => PHLEBONLY_STATUS_CLASSES[s] ?? 's0';

export const ROLES = {
  PHLEB: 'phleb',
  DRIVER: 'driver',
  ADMIN: 'admin',
  SUPER_ADMIN: 'superadmin',
  PHLEB_LEAD: 'phleb_lead'
};

export const isFieldRole = (userRole) => {
  return userRole === ROLES.PHLEB || userRole === ROLES.DRIVER || userRole === ROLES.PHLEB_LEAD;
}

export const isPhleb = (role) => {
  return role === ROLES.PHLEB || role === ROLES.PHLEB_LEAD;
}

export const isDriver = (role) => {
  return role === ROLES.DRIVER;
}

export const isAdmin = (role) => {
  return role === ROLES.ADMIN || role === ROLES.SUPER_ADMIN;
}